/**
 * Film Slider/Carousel Component
 */

import { useState, useEffect, useRef } from '@wordpress/element';
import { useFilms } from '../context/FilmContext';
import FilmCard from './FilmCard';

export default function FilmSlider({ genre, night, count = 6, perPage, title, orderby = 'rand' }) {
    const { fetchFilms, loading } = useFilms();
    const [films, setFilms] = useState([]);
    const sliderRef = useRef(null);

    const filmCount = parseInt(perPage || count);

    useEffect(() => {
        loadFilms();
    }, [genre, night, filmCount, orderby]);

    const loadFilms = async () => {
        const params = {
            per_page: filmCount,
            orderby: orderby,
        };

        if (genre) params.genre = genre;
        if (night) params.night = night;

        const result = await fetchFilms(params);
        setFilms(result.films || []);
    };

    const scroll = (direction) => {
        if (sliderRef.current) {
            const scrollAmount = 220; // Card width + gap
            sliderRef.current.scrollBy({
                left: direction * scrollAmount,
                behavior: 'smooth',
            });
        }
    };

    if (loading && films.length === 0) {
        return (
            <div className="rialto-loading">
                <div className="rialto-spinner"></div>
            </div>
        );
    }

    if (films.length === 0) {
        return null;
    }

    return (
        <div className="rialto-slider-wrapper">
            {title && <h3 className="rialto-row-title">{title}</h3>}
            <div className="rialto-slider">
            <button
                className="rialto-slider-nav prev"
                onClick={() => scroll(-1)}
                aria-label="Previous"
            >
                &larr;
            </button>

            <div className="rialto-slider-track" ref={sliderRef}>
                {films.map((film) => (
                    <div key={film.id} className="rialto-slider-item">
                        <FilmCard film={film} showReminder={false} />
                    </div>
                ))}
            </div>

            <button
                className="rialto-slider-nav next"
                onClick={() => scroll(1)}
                aria-label="Next"
            >
                &rarr;
            </button>
        </div>
        </div>
    );
}
